import * as React from 'react';
import classNames from 'classnames';
import { UIText2, UIText3 } from '@cian/ui-kit';

import { pluralDays } from '../../../../../../utils/string';
import { NBSP } from '../../../../../../constants/symbols';

import * as styles from './Duration.css';

interface IProps {
  duration: number;
  discount: number;
  checked: boolean;
  onClick(): void;
}

export const Duration = ({ duration, discount, checked, onClick }: IProps) => (
  <div className={classNames(styles['card'], checked && styles['checked'])} onClick={onClick}>
    <UIText2>{duration === 1 ? 'Посуточно' : pluralDays(duration)}</UIText2>
    {!!discount && (
      <UIText3 color="primary_100">
        Скидка{NBSP}
        {discount}%
      </UIText3>
    )}
  </div>
);
